import { render, staticRenderFns } from "./result.vue?vue&type=template&id=1d8fbe6e&lang=pug&"
import script from "./result.vue?vue&type=script&lang=js&"
export * from "./result.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "~/lang/products/banking/cards?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fubuntu%2Fnuxt%2Fbonkers%2Freleases%2F20231130131843%2Fcomponents%2Fproducts%2Fcards%2Fresult.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WidgetsImage: require('/home/ubuntu/nuxt/bonkers/releases/20231130131843/components/widgets/image.vue').default,WidgetsResultsFigure: require('/home/ubuntu/nuxt/bonkers/releases/20231130131843/components/widgets/results/figure.vue').default,WidgetsResultsFeatureChips: require('/home/ubuntu/nuxt/bonkers/releases/20231130131843/components/widgets/results/feature-chips.vue').default,WidgetsResultsCell: require('/home/ubuntu/nuxt/bonkers/releases/20231130131843/components/widgets/results/cell.vue').default,WidgetsResultsMiniTable: require('/home/ubuntu/nuxt/bonkers/releases/20231130131843/components/widgets/results/mini-table.vue').default,WidgetsResultsAccordion: require('/home/ubuntu/nuxt/bonkers/releases/20231130131843/components/widgets/results/accordion.vue').default,WidgetsTrackableLink: require('/home/ubuntu/nuxt/bonkers/releases/20231130131843/components/widgets/trackable-link.vue').default,WidgetsResultsCta: require('/home/ubuntu/nuxt/bonkers/releases/20231130131843/components/widgets/results/cta.vue').default,WidgetsResultsItem: require('/home/ubuntu/nuxt/bonkers/releases/20231130131843/components/widgets/results/item.vue').default})
